export interface ConfirmationModalDataModel{
    title: string;
    message: string;
    yesButtonText: string;
    cancelButtonText: string;
}